import styled, { css, keyframes } from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";
import type { ButtonVariant } from "./Button";
import theme from "../../constants/globalStyles/theme.json";

const { spacing } = theme;
const { colors, radius } = globalStyles;

const variantStyles = {
  primary: css`
    background-color: ${colors.primary.brown};
    color: ${colors.primary.offWhite};
    border: 1px solid ${colors.primary.brown};

    &:hover {
      background-color: ${colors.primary.green};
      border: 1px solid ${colors.primary.offWhite};
    }
  `,
  secondary: css`
    background-color: ${colors.primary.green};
    border: 1px solid ${colors.primary.offWhite};
    color: ${colors.primary.offWhite};

    &:hover {
      background-color: ${colors.hovers.primaryButton.green};
      color: ${colors.primary.offWhite};
    }
  `,
  tertiary: css`
    background-color: ${colors.primary.offWhite};
    border: 1px solid ${colors.primary.green};
    color: ${colors.primary.green};

    &:hover {
      background-color: ${colors.primary.green};
      color: ${colors.primary.offWhite};
    }
  `,
};

export const StyledButton = styled.button<{
  $variant: ButtonVariant;
}>`
  font-family: "Open Sans", sans-serif;
  padding: ${spacing.space8} ${spacing.space16};
  border-radius: ${radius.button};
  border: none;
  cursor: pointer;
  ${({ $variant }: { $variant: ButtonVariant }) => variantStyles[$variant]}
  width: 150px;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  border: 2px solid ${colors.primary.offWhite};
  border-top: 2px solid ${colors.primary.brown};
  border-radius: 50%;
  width: ${spacing.space8};
  height: ${spacing.space8};
  animation: ${spin} 1s linear infinite;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpinnerText = styled.div`
  margin-left: ${spacing.space8};
`;
